export const DUDA_ASSET_CDN = 'https://static-cdn.multiscreensite.com';
